define('home/views/common/LoginFormView',[
    'jquery',
    'underscore',

    'core/bus',
    'core/utils',
    'core/views/common/LoginFormView',

    'home/models/Session',
    'home/models/User',
], function (
    $,
    _,

    bus,
    coreUtils,
    CoreLoginFormView,

    Session,
    User
) {
    'use strict';

    var handler = coreUtils.preventDefaultHandler;

    /**
     * A parent view containing common functionality for authentication.
     * Handles validating sign up forms, showing and hiding errors,
     * and authenticating through other networks as well as disqus (ex:
     * fb, twitter)
     *
     * Not intended to be instantiated, should be extended.
     *
     * Since this view extends core/LoginFormView, it is a Backbone view, not a
     * Marionette view.
     */
    var LoginFormView = CoreLoginFormView.extend({
        events: {
            'click [data-action~=change-step]': 'changeStep',
            'click [data-action~=auth]': 'handleAuth',
            'submit [data-role=disqus-signup]': 'attemptSignup',
        },

        // Needed by LoginFormView parent class
        User: User,

        initialize: function (options) {
            CoreLoginFormView.prototype.initialize.call(this, options);

            // This event is triggered when user signs/logs in via a network
            // (ex: fb, twitter), which occurs in a separate window.
            this.listenTo(bus.frame, '!auth:success', this.handleRegistrationSuccess);

            this.session = Session.get();
        },

        close: function () {
            this.stopListening(bus.frame, '!auth:success');
            this.remove();
        },

        handleAuth: handler(function (evt) {
            var network = $(evt.target).attr('data-network');
            this.session.authenticate(network);
        }),

        attemptSignup: handler(function () {
            this.clearRegistrationErrors();
            this.registerUser();
        }),

        clearRegistrationErrors: function () {
            this.$('.form-attribute-input.is-error').removeClass('is-error');
        },

        handleRegistrationError: function (errs) {
            this.enableForm();

            _.each(errs, function (attrErrs, attrName) {
                // Show one eror message per attribute at a time.
                this.$('.form-attribute-input[data-attribute*=' + attrName + ']')
                    .addClass('is-error')
                    .find('[data-role=attribute-error]')
                    .text(attrErrs[0]);
            }, this);
        },

        handleRegistrationSuccess: function () {
            // Home does not support changing the logged in status without reloading
            window.location.reload();
        },

        changeStep: function (evt) {
            var step = $(evt.target).attr('data-target');
            this.$('[data-step]')
                .addClass('is-hidden')
                .filter('[data-step=' + step + ']')
                .removeClass('is-hidden')
                .find('input')
                .first()
                .focus();
        },

        render: function () {
            var templateHelpers = this.templateHelpers;
            if (_.isFunction(templateHelpers))
                templateHelpers = templateHelpers.call(this);

            var data = _.extend({},
                this.model && this.model.toJSON(),
                templateHelpers);

            this.$el.html(this.template(data));
            return this;
        },
    });

    return LoginFormView;
});

